<mdk-app-header [title]='title'></mdk-app-header>
<router-outlet></router-outlet>
<mdk-alert-modal></mdk-alert-modal>
<mdk-app-footer [title]='title'></mdk-app-footer>